<div class="col-12 resources">
  <div class="container-xl">
    <div class="row">
      <div class="col-12 col-sm-6 resources--head smb4">
        Explore our<br />
        resources
      </div>
      <div class="col-12 col-sm-6 text-end align-self-center smb2">
        <button class="primaryBtn secondaryBtn" (click)="viewResources()">
          VIEW ALL RESOURCES
        </button>
      </div>
      <div
        class="col-sm-12 col-md-4"
        data-aos="fade-right"
        data-aos-duration="1000">
        <div class="card resources--card">
          <img
            src="./../../assets/images/resource-image.png"
            class="card-img-top"
            alt="RESOURCES" />
          <div class="card-body">
            <h5 class="card-title">
              Three Ways Artificial Intelligence Will Improve Contact Center
              Customer Service
            </h5>
            <button class="flatBtn c-p f600">
              EXPLORE RESOURCE <i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-sm-12 col-md-4"
        data-aos="fade-up"
        data-aos-duration="1000">
        <div class="card resources--card">
          <img
            src="./../../assets/images/resource-image.png"
            class="card-img-top"
            alt="RESOURCES" />
          <div class="card-body">
            <h5 class="card-title">
              Three Ways Artificial Intelligence Will Improve Contact Center
              Customer Service
            </h5>
            <button class="flatBtn c-p f600">
              EXPLORE RESOURCE <i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        class="col-sm-12 col-md-4"
        data-aos="fade-left"
        data-aos-duration="1000">
        <div class="card resources--card">
          <img
            src="./../../assets/images/resource-image.png"
            class="card-img-top"
            alt="RESOURCES" />
          <div class="card-body">
            <h5 class="card-title">
              Three Ways Artificial Intelligence Will Improve Contact Center
              Customer Service
            </h5>
            <button class="flatBtn c-p f600">
              EXPLORE RESOURCE <i class="bi bi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
